
import React from 'react';
import { Link } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

const Header = () => {
  const { t, i18n } = useTranslation();
  return (
  <header className="app-header" role="banner">
    <h1>
      <Link to="/">{t('app.title')}</Link>
    </h1>
    <p className="app-description">{t('app.description')}</p>
    <div className="language-selector" role="navigation" aria-label="Language selector">
      <button
        className={i18n.language === 'es' ? 'active' : ''}
        onClick={() => i18n.changeLanguage('es')}
        aria-label={t('buttons.switchToSpanish')}
      >
        ES
      </button>
      <button
        className={i18n.language === 'en' ? 'active' : ''}
        onClick={() => i18n.changeLanguage('en')}
        aria-label={t('buttons.switchToEnglish')}
      >
        EN
      </button>
    </div>
  </header>
  )
};

export default Header;
